'use strict';

var GridToolbarConfigurationBudgetTargetDirective = function GridToolbarConfigurationBudgetTargetDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-configuration-budget-target.html'),
    controller: 'GridToolbarConfigurationBudgetTargetController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarConfigurationBudgetTargetDirective.$inject = [];
module.exports = GridToolbarConfigurationBudgetTargetDirective;